import { _ as a, f as e, t as o } from "./export-cdcbfb2b.js";
import { o as s } from "./object-keys-719a5561.js";
var f = a, c = o, t = s, i = e, n = i(function() {
  t(1);
});
f({ target: "Object", stat: !0, forced: n }, {
  keys: function(r) {
    return t(c(r));
  }
});
